module.exports = __webpack_public_path__ + "static/images/calendar-dark.cef2f10bbdf7e76df6e574576d2f2baa.svg";